import React, {useState} from "react"
import './Step2File.scss'
import {Form, Row, Col, Input, Select, Upload, Icon, Button, message} from 'antd';
import { useTranslation } from "react-i18next";
import apiConfig from '../../../../../../config/api'
import formTypeValidator from "../../../../../../helpers/formTypeValidator";

const Step2File = ({form, sendFormFile , prev, currentUser}) => {
    const { t } = useTranslation()
    const { getFieldDecorator, validateFields, setFieldsValue } = form;
    const { Dragger } = Upload;
    const [tmpFilesList, setTmpFilesList] = useState([])
    const [ category, setCategory ] = useState(null)
    const [ submitting, setSubmitting] = useState(false)

    const formItemLayout = {
        labelCol: {span: 9},
        wrapperCol: {span : 12},
      };

    const propsUpload = {
        accept: ".xlsx",
        onRemove: file => {
          setTmpFilesList(oldTmpFilesList => {
            const index = oldTmpFilesList.indexOf(file)
            const newTmpFilesList = oldTmpFilesList.slice()

            newTmpFilesList.splice(index, 1)

            return newTmpFilesList
          })
        },
        beforeUpload: file => {
          if(tmpFilesList.length === 0) {
            setTmpFilesList(oldTmpFilesList => [...oldTmpFilesList, file])
          }

          return false
        },
        multiple: false,
        fileList: tmpFilesList,
      }

    const handleChangeCategory = (value) => {
        setCategory(value)
        setFieldsValue({ declType: undefined })
    }

    const nextStepLocal = () => {
        if (submitting) return;

        validateFields(['category', 'declType']).then((c) => {
            if(tmpFilesList.length === 0){
                message.error(t('messages.aml.cdi.step2File.mustUpload'));
            }else{
                setSubmitting(true);
                sendFormFile(c.declType, c.category, tmpFilesList[0], () => setSubmitting(false));
            }
        })
      }

    const downloadPlantilla = () => {
        window.open(apiConfig.url + '/../templates/carga_registro.xlsx')
    }

    return (
        <div className="step2file-content">
            <div className="step2file-title">
                { t('messages.aml.cdi.step2File.heading') }
            </div>
            <Row>
                <Form {...formItemLayout}>
                    <Col span={11}>
                        <Form.Item label={ t('messages.aml.cdi.steps.categoryLabel') } >
                            { getFieldDecorator('category', {
                                rules: [{
                                    required: true,
                                    message: t('messages.aml.cdi.step2File.categoryRequired')
                                }]
                            })(
                                <Select placeholder={ t('messages.aml.cdi.steps.categoryPlaceholder') } onChange={handleChangeCategory}>
                                    <Select.Option value="CLIENTE">{ t('messages.aml.cdi.steps.catCliente') }</Select.Option>
                                    <Select.Option value="COLABORADOR">{ t('messages.aml.cdi.steps.catColaborador') }</Select.Option>
                                    <Select.Option value="PROVEEDOR">{ t('messages.aml.cdi.steps.catProveedor') }</Select.Option>
                                    <Select.Option value="DIRECTOR">{ t('messages.aml.cdi.steps.catDirector') }</Select.Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={11}>
                        <Form.Item label={ t('messages.aml.cdi.steps.declTypeLabel') }>
                            { getFieldDecorator('declType', {
                                rules: [{
                                    required: true,
                                    message: t('messages.aml.cdi.step2File.declTypeRequired')
                                }]
                            })(
                                <Select placeholder={ t('messages.aml.cdi.steps.declTypePlaceholder') }>
                                    {formTypeValidator(currentUser, category).map(type => {
                                        return <Select.Option value={type}>{t('messages.aml.type.'+type)}</Select.Option>
                                    })}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Form>
              <Col span={2}>
                <div className="plantilla"><a onClick={downloadPlantilla}>{ t('messages.aml.cdi.step2File.plantilla') }</a></div>
              </Col>
            </Row>
            <div className= "next2file-dragger">
                <Row style={{marginBottom: 30}}>
                    <Col span={24}>
                        <Dragger {...propsUpload}>
                            <p className="ant-upload-drag-icon">
                            <Icon type="inbox" />
                            </p>
                            <p className="ant-upload-text">{ t('messages.aml.cdi.step2File.dragText') }</p>
                            <p className="ant-upload-hint">
                                { t('messages.aml.cdi.step2File.dragHint') }
                            </p>
                        </Dragger>
                    </Col>
                </Row>
            </div>
            <div className="steps-buttons">
                <Button  onClick={() => prev()}>
                    { t('messages.aml.cdi.steps.prev') }
                </Button>
                <Button style={{ marginLeft: 8 }} type="primary" onClick={() => nextStepLocal()} disabled={submitting}>
                    {t('messages.aml.cdi.steps.send') }
                </Button>
            </div>
        </div>
    )
}
export default Form.create()(Step2File);
